import { o_util } from "@gr-common/async/namespaces";
import { otto } from "@gr-exports/async/nexus";
const core = o_util.core ?? {};
const isEmptyObject = core.isEmptyObject;
const isPlainObject = core.isPlainObject;
const withMacrotask = core.withMacrotask;
const withRenderSlice = core.withRenderSlice;
const coreasync = otto.grcore ?? {};
const runWithMicrotask = coreasync.runWithMicrotask;
const runWithMacrotask = coreasync.runWithMacrotask;
const runWithAnimationFrame = coreasync.runWithAnimationFrame;
const runWithRenderSlice = coreasync.runWithRenderSlice;
const coerce = core.coerce;
const deserialize = core.deserialize;
const serialize = core.serialize;
const serializeForm = core.serializeForm;
export {
  coerce,
  core,
  coreasync,
  deserialize,
  isEmptyObject,
  isPlainObject,
  runWithAnimationFrame,
  runWithMacrotask,
  runWithMicrotask,
  runWithRenderSlice,
  serialize,
  serializeForm,
  withMacrotask,
  withRenderSlice
};
